import { Urls as ServerUrls } from './store/types';

const dockerDomain = process.env.DOCKER_DOMAIN;
const dockerPrLabel = process.env.DOCKER_PR_LABEL;

const isInGithubCodespaces = process.env.CODESPACES === 'true';

export const defaultServerUrls: { [environment: string]: ServerUrls } = {
  develop: {
    authorizationApiUrl: 'https://developauth.paragontruss.com/',
    sealingServerApiUrl: 'https://sealingserver-develop.paragontruss.com/api/',
    designServiceApiUrl: 'https://designserver-develop.paragontruss.com/api/',
    synchronizationServerUrl: 'wss://developsync.paragontruss.com/',
    synchronizationServerApiUrl: 'https://developsync.paragontruss.com/api/',
  },
  'release-candidate': {
    authorizationApiUrl: 'https://rcauth.paragontruss.com/',
    sealingServerApiUrl: 'https://sealingserver-releasecandidate.paragontruss.com/api/',
    designServiceApiUrl: 'https://designserver-releasecandidate.paragontruss.com/api/',
    synchronizationServerUrl: 'wss://rcsync.paragontruss.com',
    synchronizationServerApiUrl: 'https://rcsync.paragontruss.com/api/',
  },
  localhost: {
    authorizationApiUrl: process.env.PARAGON_LOCAL_AUTHORIZATION_API_URL ?? 'https://developauth.paragontruss.com/',
    sealingServerApiUrl:
      process.env.PARAGON_LOCAL_SEALING_SERVER_API_URL ??
      // HTTPS does not play nicely with GitHub Codespaces
      (isInGithubCodespaces ? 'http://localhost:54779/api/' : 'https://localhost:44300/api/'),
    designServiceApiUrl:
      process.env.PARAGON_LOCAL_DESIGN_SERVICE_API_URL ??
      // HTTPS does not play nicely with GitHub Codespaces
      (isInGithubCodespaces ? 'http://localhost:59517/api/' : 'https://localhost:44371/api/'),
    synchronizationServerUrl:
      process.env.PARAGON_LOCAL_SYNCHRONIZATION_SERVER_URL ?? 'wss://developsync.paragontruss.com/',
    synchronizationServerApiUrl:
      process.env.PARAGON_LOCAL_SYNCHRONIZATION_SERVER_API_URL ?? 'https://developsync.paragontruss.com/api/',
  },
  production: {
    authorizationApiUrl: 'https://auth.paragontruss.com/',
    sealingServerApiUrl: 'https://sealingserver.paragontruss.com/api/',
    designServiceApiUrl: 'https://designserver.paragontruss.com/api/',
    synchronizationServerUrl: 'wss://sync.paragontruss.com',
    synchronizationServerApiUrl: 'https://sync.paragontruss.com/api/',
  },
  docker: {
    authorizationApiUrl: `https://${dockerPrLabel}auth.${dockerDomain}/`,
    sealingServerApiUrl: `https://${dockerPrLabel}sealingserver.${dockerDomain}/api/`,
    designServiceApiUrl: `https://${dockerPrLabel}designserver.${dockerDomain}/api/`,
    synchronizationServerUrl: `wss://${dockerPrLabel}sync.${dockerDomain}/`,
    synchronizationServerApiUrl: `https://${dockerPrLabel}sync.${dockerDomain}/api/`,
  },
};
